<script>
import {
  trainerComputed,
  trainerMethods,
  authMethods,
  authComputed,
  adminPanelComputed,
  adminPanelMethods,
  clientComputed,
  organizationComputed,
} from '@state/helpers';

export default {
  props: {
    product: {
      type: Object,
      required: true,
      default: () => {},
    },
    subscribers: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  mounted() {},
  computed: {
    ...adminPanelComputed,
    ...trainerComputed,
    ...clientComputed,
    ...authComputed,
    ...organizationComputed,
    isSubscription() {
      return this.product &&
        this.product.type &&
        this.product.type === 'recurring'
        ? 'Yes'
        : 'No';
    },
  },
  methods: {
    ...adminPanelMethods,
    ...trainerMethods,
    ...authMethods,
    missingDataHandler() {
      window.location.href =
        'mailto:' +
        this.organizationSupportEmail +
        '?subject=' +
        this.organizationTitle +
        ' Beta Product Management';
    },
    buildInterval(interval, intervalCount) {
      if (interval === 'week') {
        return intervalCount > 1 ? `${intervalCount}wk` : `${intervalCount}wk`;
      } else if (interval === 'month') {
        return intervalCount > 1
          ? `${intervalCount}mth`
          : `${intervalCount}mth`;
      } else if (interval === 'year') {
        return intervalCount > 1 ? `${intervalCount}yr` : `${intervalCount}yr`;
      }
    },
    viewProductDetails() {
      this.$emit('view-product-details', this.product);
    },
    getSubscriberAvatar(subscriber) {
      return subscriber &&
        subscriber.profile &&
        subscriber.profile.mediaAssets &&
        subscriber.profile.mediaAssets.avatarImage &&
        subscriber.profile.mediaAssets.avatarImage.url
        ? subscriber.profile.mediaAssets.avatarImage.url
        : require('@assets/images/placeholder-avatar.png');
    },
  },
};
</script>

<template>
  <div
    :class="[
      'product-container',
      'row',
      { isSelected: selectedProduct && product.id === selectedProduct.id },
    ]"
    @click="viewProductDetails"
  >
    <div class="card-product-details-wrapper">
      <span class="title">{{
        product && product.nickname ? product.nickname : 'No name'
      }}</span>
      <div class="col">
        <div class="subdata row">
          <span class="subtitle">DURATION</span>
          <span class="figure"
            >{{
              product.type === 'one_time'
                ? 'Once'
                : buildInterval(
                    product.recurring.interval,
                    product.recurring.interval_count
                  )
            }}
          </span>
        </div>
        <div class="divider-horizontal">&nbsp;</div>
        <div class="subdata row">
          <span class="subtitle">PRICE</span>
          <span class="figure"
            >${{
              product.object === 'price'
                ? parseFloat(product.unit_amount / 100)
                : parseFloat(product.amount / 100)
            }}
          </span>
        </div>
        <div class="divider-horizontal">&nbsp;</div>
        <div class="subdata row">
          <span class="subtitle">SUBSCRIPTION</span>
          <span class="figure">{{ isSubscription }}</span>
        </div>
        <div class="divider-horizontal">&nbsp;</div>
        <div class="subdata row">
          <span class="subtitle">Subscribers</span>
          <span class="figure">{{ subscribers.length }}</span>
        </div>
        <div class="subscribers row">
          <template v-for="(subscriber, i) in subscribers">
            <img
              v-if="i < 3"
              :key="subscriber._id"
              :src="getSubscriberAvatar(subscriber)"
            />
          </template>
          <span
            v-if="subscribers && subscribers.length > 3"
            class="more-subscribers"
          >
            {{ `+${subscribers.length - 3}` }}
          </span>
          <span class="edit-product">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M7 11.666h5.25M9.875 2.362a1.237 1.237 0 011.75 1.75l-7.292 7.292L2 11.987l.583-2.333 7.292-7.292z" stroke="#000" stroke-linecap="round" stroke-linejoin="round"/></svg>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.product-container {
  background-color: white;
  border: unset;
  border-radius: 8px;
  flex: 0 0 23%;
  height: 30vh;
  margin-bottom: 2%;
  margin-left: 0;
  margin-right: 2%;
  max-height: 30vh;
  max-width: 23%;
  min-height: 30vh;
  min-height: 28rem;
  padding: 1% 2% 2% 2%;
  transition: transform 300ms;
  transition-timing-function: ease-out;
  &:hover {
    box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
    cursor: pointer;
    transform: scale(1.01);
  }
  &.isSelected {
    box-shadow: 0 0.4rem 0.8rem rgba($color-black-wo-rgb, 0.1);
    transform: scale(1.01);
  }
  .card-product-details-wrapper {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    margin-bottom: 0.8rem;
    padding-bottom: 2rem;
    padding-top: 2rem;
    position: relative;
    width: 100%;
    .title {
      align-items: center;
      align-self: flex-start;
      color: $color-black-one;
      display: flex;
      font-size: 21px;
      font-style: normal;
      font-weight: 900;
      letter-spacing: -0.3px;
      line-height: 24px;
    }
    .subdata {
      align-items: center;
      display: flex;
      justify-content: space-between;
      justify-self: center;
      margin-bottom: 0.8rem;
      margin-left: 3%;
      margin-top: 0.8rem;
      width: 95%;
      .subtitle {
        color: $color-medium-gray-two;
        font-size: 10px;
        font-weight: 900;
        letter-spacing: 0.702381px;
        line-height: 19px;
        text-transform: uppercase;
      }
      .figure {
        color: $color-black-one;
        font-weight: normal;
        letter-spacing: -0.0666664px;
        mix-blend-mode: normal;
        opacity: 0.6;
        text-align: right;
      }
    }
    .col {
      padding-left: 0;
      padding-right: 0;
    }
    .divider-horizontal {
      align-self: center;
      border-top: 1px solid $color-gray;
      height: 0.5rem;
      margin-left: auto;
      margin-right: auto;
      opacity: 0.5;
      opacity: 0.2;
      width: 100%;
    }
    .subscribers {
      margin-left: 0;
      margin-right: 0;
      margin-top: 1.5rem;
      img {
        border-radius: 50%;
        height: 3rem;
        margin-right: 9px;
        width: 3rem;
      }
      .edit-product {
        border: 2px solid $color-action;
        border-radius: 50%;
        height: 3rem;
        margin-left: 0.5rem;
        width: 3rem;
        svg {
          fill: white;
          height: 2.3rem;
          outline: unset;
          width: 2.3rem;
          path {
            stroke: $color-action;
          }
        }
        &:hover {
          background-color: $color-action;
          svg {
            fill: $color-action;
            height: 2.3rem;
            outline: unset;
            width: 2.3rem;
            path {
              stroke: white;
            }
          }
        }
      }
      .more-subscribers {
        @extend .edit-product;

        align-items: center;
        background-color: white;
        color: black;
        display: flex;
        font-weight: 800;
        justify-content: center;
        margin-left: unset;
        &:hover {
          color: white;
        }
      }
    }
  }
}
</style>
